import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, Divider, IconButton,
    ListItem, ListItemButton,
    ListItemSecondaryAction,
    ListItemText
} from "@mui/material";
import React from "react";
import {IInspection} from "../../rest-data-provider/bfaTypes";
import {format, parse} from "date-fns";
import List from '@mui/material/List';
import {FaExternalLinkAlt} from "react-icons/fa";

export interface InspectionsListDialogProps {
    open: boolean;
    handleClose: () => void;
    inspections: IInspection[];
    didSelectInspection: (inspection: IInspection) => void
}

export const InspectionsListDialog : React.FC<InspectionsListDialogProps> = ({inspections, open, handleClose, didSelectInspection}) => {


    return(
        <Dialog fullWidth maxWidth={'md'} open={open} onClose={handleClose}>
            <DialogTitle>Übersicht Prüfungen</DialogTitle>
            <DialogContent>
                <List>
                    {inspections.map(inspection => {

                        return (
                            <>
                                <ListItem secondaryAction={
                                    <IconButton onClick={() => {
                                        const resource = "inspections";
                                        const action = "show";
                                        const id = inspection.id;

                                        const url = `/${resource}/${action}/${id}`;

                                        window.open(url, "_blank");
                                    }}><FaExternalLinkAlt size={20} /></IconButton>
                                }>
                                    <ListItemButton onClick={event => {
                                        didSelectInspection(inspection);
                                    }}>
                                        <ListItemText primary={<><b>{inspection.customer.name}</b>{inspection.facility.name ? ' - ' +inspection.facility.name : ''}</>}
                                                      secondary={
                                                          inspection.begin
                                                              ? `${format(parse(inspection.begin, 'yyyy-MM-dd', new Date()), 'dd.MM')} - ${
                                                                  inspection.end
                                                                      ? format(parse(inspection.end, 'yyyy-MM-dd', new Date()), 'dd.MM.yyyy')
                                                                      : 'laufend'
                                                              }`
                                                              : 'unbekannt'}></ListItemText>
                                    </ListItemButton>

                                </ListItem>
                                <Divider></Divider>
                            </>

                        )
                    })}

                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Schließen</Button>
            </DialogActions>
        </Dialog>
    )
}